import { Input } from 'antd';
import React from 'react';
import UserAvatar from './common/UserAvatar';

const EditUserNameAvatar = ({
  tempAvatar,
  onNameChange,
  nameValue,
}: {
  tempAvatar: string | null;
  onNameChange: (name: string) => void;
  nameValue: string;
}) => {
  return (
    <>
      <div className='onboarding-title'>this is your avatar</div>
      <div className='onboarding-subtitle'>
        this is what people will see when they enter the party...
      </div>
      <div className='onboarding-avatar'>
        <UserAvatar size={128} src={tempAvatar} />
      </div>
      <div className='onboarding-name'>
        <Input
          style={{ width: '100%' }}
          placeholder='choose a name'
          autoFocus
          value={nameValue}
          onChange={(e) => onNameChange(e.target.value)}
          className='onboarding-name-input'></Input>
      </div>
    </>
  );
};

export default EditUserNameAvatar;
